/* Cart-drawer "recently viewed" strip.
   Reads the localStorage store written by recently-viewed-products.js on each PDP view, fetches the
   bokja-recently-viewed section via the search section-rendering endpoint (id: query, the pattern
   Horizon's predictive search already uses), and injects it when the cart drawer opens.

   Loaded as a real asset via <script src> from bokja-cart-drawer.liquid because a {% javascript %}
   block in that header-rendered snippet does NOT get bundled/executed (verified live: the snippet's
   {% stylesheet %} bundles but its {% javascript %} never runs). Same lesson as the PDP JS (T1).

   Fail-safe: any error just keeps the strip hidden, so the cart is never affected. Self-guarded so a
   single load covers the whole session (the cart drawer is persistent in the header). */
(function () {
  if (window.__bokjaCartRecentsBound) return;
  window.__bokjaCartRecentsBound = true;

  function ids() {
    try { return JSON.parse(localStorage.getItem('viewedProducts') || '[]'); } catch (e) { return []; }
  }

  var lastKey = null;
  async function load() {
    if (window.__bokjaCartBusy) return;
    var wrap = document.querySelector('[data-bokja-recents]');
    var mount = wrap && wrap.querySelector('.bokja-recents__mount');
    if (!wrap || !mount) return;
    var list = ids();
    // 2026-09-18 (James): never offer what is already in the basket; with nothing left, the strip hides
    // and "Complete the collection" leads. The key carries the cart's product ids so a change re-renders.
    var inCart = [];
    try { var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); inCart = cart.items.map(function (i) { return String(i.product_id); }); } catch (e) { inCart = []; }
    list = list.filter(function (id) { return inCart.indexOf(String(id)) === -1; });
    if (!list.length) { wrap.hidden = true; lastKey = null; return; }
    var key = list.join(',') + '|' + inCart.join(',');
    if (key === lastKey && mount.children.length) { wrap.hidden = false; return; }   // cache between opens
    var q = list.map(function (id) { return 'id:' + id; }).join(' OR ');
    try {
      var res = await fetch('/search?type=product&q=' + encodeURIComponent(q) + '&section_id=bokja-recently-viewed', { headers: { 'Accept': 'text/html' } });
      if (!res.ok) { wrap.hidden = true; return; }
      var html = (await res.text()).trim();
      mount.innerHTML = html;
      var row = mount.querySelector('.bokja-recents__row');
      if (row) {
        list.forEach(function (id) {                                                  // re-order to match recency
          var el = row.querySelector('[data-bokja-recent-id="' + id + '"]');
          if (el) row.appendChild(el);
        });
      }
      var has = !!(row && row.children.length);
      wrap.hidden = !has;
      lastKey = has ? key : null;
    } catch (e) { wrap.hidden = true; }
  }

  // Trigger on drawer open. Two independent signals for robustness:
  // 1) MutationObserver on the dialog's [open] (covers auto-open after add-to-cart).
  // 2) Delegated click on the cart trigger (covers the manual open).
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var d = muts[i].target;
        if (d.nodeType === 1 && d.classList && d.classList.contains('cart-drawer__dialog') && d.hasAttribute('open')) load();
      }
    });
    var watch = function () {
      var dlg = document.querySelector('.cart-drawer__dialog');
      if (dlg && !dlg.__bokjaRecentsWatched) {
        dlg.__bokjaRecentsWatched = true;
        obs.observe(dlg, { attributes: true, attributeFilter: ['open'] });
        if (dlg.hasAttribute('open')) load();
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.bokja-nav__cart--trigger, [data-testid="cart-drawer-trigger"]');
    if (t) setTimeout(load, 60);
  }, true);
  // 2026-09-18: in-drawer adds and removals recompute the strip (same observer shape as bokja-cart-pair.js)
  var itemsObs = new MutationObserver(function () { clearTimeout(itemsObs.__t); itemsObs.__t = setTimeout(load, 350); });
  function watchItems() { var items = document.querySelector('.cart-drawer__items'); if (items && !items.__bokjaRecentsItemsWatched) { items.__bokjaRecentsItemsWatched = true; itemsObs.observe(items, { childList: true, subtree: true }); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchItems); else watchItems();
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-bokja-quickadd], .bokja-nav__cart--trigger, [data-testid="cart-drawer-trigger"]')) setTimeout(watchItems, 400); }, true);

  // 2026-09-18 (James): the drawer can open by itself after an add and its dialog can be rebuilt, so the
  // [open] observer above is not enough. Three more triggers: the theme's own cart event, an [open]
  // observer over the whole page, and a quiet re-check every 4 s while the drawer is open.
  document.addEventListener('cart:update', function () { watchItems(); setTimeout(load, 400); });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { var d = muts[i].target; if (d.nodeType === 1 && d.classList && d.classList.contains('cart-drawer__dialog') && d.hasAttribute('open')) { watchItems(); setTimeout(load, 300); } }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
  setInterval(function () { if (document.querySelector('.cart-drawer__dialog[open]')) { watchItems(); load(); } }, 4000);
})();
